<template>
  <div>
    <h5 class="text-center">
      {{ translatedFields["please_provide_insurance_information"] }}
    </h5>
    <div class="row">
      <div class="col-md-11 col-md-offset-1 margin">
        <fieldset>
          <div class="form-group">
            <form @submit.prevent="triggerNextTab">
              <label class="col-sm-4" id="select-payment">
                {{ translatedFields["select_payment_type"] }}
              </label>
              <div class="col-sm-6">
                <p-radio
                  v-model="model.insurance_pay"
                  @input="switchInsuranceCash"
                  value="true"
                  inline
                  label="insurance"
                  >{{ translatedFields["insurance"] }}</p-radio
                >
                <p-radio
                  v-model="model.insurance_pay"
                  @input="switchInsuranceCash"
                  inline
                  label="uninsured"
                  >{{ translatedFields["uninsured"] }}</p-radio
                >
                <p-radio
                  v-if="allow_client_bill && $store.state.allows_client_bill"
                  v-model="model.insurance_pay"
                  @input="switchInsuranceCash"
                  inline
                  label="client_bill"
                  >{{ translatedFields["client_bill"] }}</p-radio
                >
                <p-radio
                  v-if="allow_cash"
                  v-model="model.insurance_pay"
                  @input="switchInsuranceCash"
                  inline
                  label="cash"
                  >{{ translatedFields["cash"] }}</p-radio
                >
              </div>
              <input type="submit" value="Submit" hidden />
            </form>
          </div>
        </fieldset>
      </div>
    </div>
      
    <div v-if="this.model.insurance_pay === 'insurance'" class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <small
            >*{{
              translatedFields[
                "if_your_insurance_is_not_available_in_the_list_please_select_other"
              ]
            }}</small
          >
        </div>
      </div>
    </div>

    <form @submit.prevent="triggerNextTab">
      <div
        v-if="
          this.model.insurance_pay !== 'uninsured' &&
            model.primary_insurance != 'Client Bill'
        "
        class="row"
      >
        <div class="col-md-5 col-md-offset-1">
          <div class="form-group">
            <label class="control-label required">
              {{ translatedFields["primary_insurance_name"] }}
            </label>
            <el-select
              :disabled="
                this.model.insurance_pay === 'uninsured' ||
                  this.model.insurance_pay === 'cash'
              "
              filterable
              type="text"
              size="large"
              popper-class="select-small-options"
              data-vv-as="Primary Insurance Name"
              v-validate="modelValidations.primary_insurance"
              name="primary_insurance"
              placeholder="ex: Aetna"
              v-model="model.primary_insurance"
            >
              <el-option
                v-for="option in this.$store.state.insurance"
                class="select-danger"
                :value="option.name"
                :label="'* ' + option.name"
                :key="option.name"
              >
              </el-option>
            </el-select>
            <small class="text-danger" v-show="primary_insurance.invalid">
              {{ getError("primary_insurance") }}
            </small>
          </div>
        </div>
        <!--      policy number-->
        <div class="col-md-5">
          <div class="form-group">
            <label class="control-label" :class="(model.primary_insurance.toLowerCase().includes('self') && !model.primary_insurance.toLowerCase().includes('fund')) ? '' : 'required' ">
              {{ translatedFields["policy_number"] }}
            </label>
            <input
              class="form-control"
              :disabled="
                this.model.insurance_pay === 'uninsured' ||
                  this.model.insurance_pay === 'cash'
              "
              type="text"
              data-vv-as="Policy Number"
              name="policy_number"
              v-validate="{ required: model.primary_insurance.toLowerCase().includes('self') && !model.primary_insurance.toLowerCase().includes('fund') ? false : true }"
              v-model="model.policy_number"
              placeholder="ex: 123456789"
            />
            <small
              class="text-danger"
              v-show="
                model.policy_number.invalid || model.relationship !== 'Self'
              "
            >
              {{ getError("policy_number") }}
            </small>
          </div>
        </div>
      </div>
        
      <div
        v-if="
          this.model.insurance_pay !== 'uninsured' &&
            model.primary_insurance != 'Client Bill'
        "
        class="row"
      >
        <!--Group Number -->
        <div class="col-md-5 col-md-offset-1">
          <div class="form-group">
            <label class="control-label">
              {{ translatedFields["group_number"] }}
            </label>
            <input
              class="form-control"
              :disabled="
                this.model.insurance_pay === 'uninsured' ||
                  this.model.insurance_pay === 'cash'
              "
              type="text"
              data-vv-as="Group Number"
              name="group_number"
              v-validate="modelValidations.group_number"
              v-model="model.group_number"
              placeholder="ex: 123456789"
            />
            <small class="text-danger" v-show="group_number.invalid">
              {{ getError("group_number") }}
            </small>
          </div>
        </div>

        <!-- Relationship to Patient:-->
        <div class="col-md-5">
          <label class="control-label required">
            {{ translatedFields["relationship_to_patient"] }} </label
          ><br />
          <el-select
            :disabled="
              this.model.insurance_pay === 'uninsured' ||
                this.model.insurance_pay === 'cash'
            "
            size="large"
            data-vv-as="Relationship"
            v-validate="modelValidations.relationship"
            placeholder="Single Select"
            name="relationship"
            v-model="model.relationship"
          >
            <el-option
              v-for="option in relationshipList"
              class="select-danger"
              :value="option.value"
              :label="translateFields(option)"
              :key="option.label"
            >
            </el-option>
          </el-select>
          <small class="text-danger" v-show="relationship.invalid">
            {{ getError("relationship") }}
          </small>
        </div>

      </div>
      <input type="submit" value="Submit" hidden />
    </form>

    <div
      v-if="
        this.model.insurance_pay !== 'uninsured' &&
          model.primary_insurance != 'Client Bill'
      "
      class="row"
    >
      <!-- Insured first name -->
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields["insured_first_name"] }}
          </label>
          <input
            class="form-control"
            :disabled="
              this.model.insurance_pay === 'uninsured' ||
                this.model.insurance_pay === 'cash' ||
                this.model.relationship === 'Self'
            "
            type="text"
            data-vv-as="Insured First Name"
            name="insured_first_name"
            v-validate="modelValidations.insured_first_name"
            v-model="model.insured_first_name"
            placeholder="ex: John Smith"
          />
          <small class="text-danger" v-show="insured_first_name.invalid">
            {{ getError("insured_first_name") }}
          </small>
        </div>
      </div>

      <!-- Insured last name -->
      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields["insured_last_name"] }}
          </label>
          <input
            class="form-control"
            :disabled="
              this.model.insurance_pay === 'uninsured' ||
                this.model.insurance_pay === 'cash' ||
                this.model.relationship === 'Self'
            "
            type="text"
            data-vv-as="Insured Last Name"
            name="insured_last_name"
            v-validate="modelValidations.insured_last_name"
            v-model="model.insured_last_name"
            placeholder="ex: John Smith"
          />
          <small class="text-danger" v-show="insured_last_name.invalid">
            {{ getError("insured_last_name") }}
          </small>
        </div>
      </div>
    </div>

    <div
      v-if="
        this.model.insurance_pay !== 'uninsured' &&
          model.primary_insurance != 'Client Bill'
      "
      class="row"
    >
      <!--insured date of birth-->
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields["insured_date_of_birth"] }}
          </label>
          <input
            class="form-control date-insured-cleave-format"
            :disabled="
              this.model.insurance_pay === 'uninsured' ||
                this.model.insurance_pay === 'cash' ||
                this.model.relationship === 'Self' ||
                this.model.insurance_pay === 'client_bill'
            "
            type="text"
            data-vv-as="Insured Date of Birth"
            name="insured_date_of_birth_pretty"
            v-validate="modelValidations.insured_date_of_birth_pretty"
            v-model="model.insured_date_of_birth_pretty"
            v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
            @change="validateDate($event.target.value)"
            placeholder="ex: 12/22/1980"
            maxlength="10"
          />
          <small class="text-danger" v-if="errorDate" v-text="errorDate">
            {{ errorDate }}
          </small>
        </div>
      </div>

      <!-- insured gender -->
      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label required">
            {{ translatedFields["insured_gender"] }}
          </label>
          <el-select
            size="large"
            :disabled="
              this.model.insurance_pay === 'uninsured' ||
                this.model.insurance_pay === 'cash' ||
                this.model.relationship === 'Self'
            "
            data-vv-as="Insured Gender"
            v-validate="modelValidations.insured_gender"
            placeholder="Single Select"
            name="insured_gender"
            v-model="model.insured_gender"
          >
            <el-option
              v-for="option in $store.state.gender"
              class="select-danger"
              :value="option.name"
              :label="option.name"
              :key="option.name"
            >
            </el-option>
          </el-select>
          <small class="text-danger" v-show="insured_gender.invalid">
            {{ getError("insured_gender") }}
          </small>
        </div>
      </div>
    </div>

    <div
      v-if="
        this.model.insurance_pay != 'uninsured' &&
          model.primary_insurance != 'Client Bill'
      "
      class="row"
    >
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <small
            >*{{
              translatedFields["address_is_the_same_as_previously_entered"]
            }}</small
          >
          <p-checkbox
            :disabled="
              this.model.insurance_pay === 'uninsured' ||
                this.model.insurance_pay === 'cash' ||
                this.model.relationship === 'Self'
            "
            v-model="same_address"
            class="display-inline"
            name="same_address"
          >
          </p-checkbox>
        </div>
      </div>
    </div>

    <div
      v-if="
        this.model.insurance_pay != 'uninsured' &&
          model.primary_insurance != 'Client Bill'
      "
      class="row"
    >
      <!--insured address-->
      <div class="col-md-10 col-md-offset-1">
        <Address
          id="insurance"
          @updateAddress="updateAddress"
          :componentsInsurance="sameAddress"
          wizardStep="insurance"
        />
        <small class="text-danger" v-if="address_error" v-text="address_error">
          {{ address_error }}
        </small>
      </div>
    </div>

    <div
      v-if="
        this.model.insurance_pay != 'uninsured' &&
          allow_insurance_card &&
          model.primary_insurance != 'Client Bill'
      "
      class="row"
    >
      <div class="col-md-10 col-md-offset-1">
        <label
          class="control-label"
          :class="{ required: required_insurance_card }"
        >
          {{ translatedFields["insurance_card"] }}
        </label>
        <label for="insurance_card_image" class="upload-file-label">
          <h6 v-if="!model.insurance_card_name">Choose file or take picture</h6>
          <h6 v-else class="elipsis">{{ model.insurance_card_name }}</h6>
          <input
            :disabled="
              this.model.insurance_pay === 'uninsured' ||
                this.model.insurance_pay === 'cash'
            "
            class="upload-file"
            type="file"
            name="insurance_card_image"
            id="insurance_card_image"
            data-vv-as="Insurance Card"
            v-validate="modelValidations.insurance_card_image"
            @change="onFileChangeInsurance"
            accept=".png, .jpg, .jpeg, .svg, .gif, .webp, .tiff, .bmp, .ico, .tif, .pdf"
          />
        </label>
        <small class="text-danger" v-show="insurance_card_image.invalid">
          {{ getError("insurance_card_image") }}
        </small>
      </div>
    </div>
    <br />

    <div
      v-if="
        this.model.insurance_pay == 'uninsured' && allow_dl_or_ssn === 'true'
      "
      class="row"
    >
      <!-- Driver license number  -->
      <div class="col-md-4 col-md-offset-1">
        <div class="form-group">
          <label class="control-label">
            {{ translatedFields["driver_license_number"] }}
          </label>
          <input
            class="form-control"
            type="text"
            data-vv-as="Driver License Number"
            name="driver_license_number"
            v-validate="modelValidations.driver_license_number"
            v-model="model.driver_license_number"
          />
        </div>
      </div>

      <div class="col-md-1">
        <div class="form-group">
          <label class="control-label"> </label>
          <small class="form-control border-none">or</small>
        </div>
      </div>

      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label">
            {{ translatedFields["social_security_number"] }}
          </label>
          <input
            class="form-control"
            type="number"
            data-vv-as="Social Security Number"
            name="social_security_number"
            v-validate="modelValidations.social_security_number"
            v-model="model.social_security_number"
          />
          <small class="text-danger" v-show="social_security_number.invalid">
            {{ getError("social_security_number") }}
          </small>
        </div>
      </div>

      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <input
            class="form-control display-none"
            type="text"
            data-vv-as="Social Number"
            name="error_uninsured"
            v-validate="modelValidations.error_uninsured"
            v-model="model.error_uninsured"
            placeholder="ex: John Smith"
          />
          <small class="text-danger" v-show="error_uninsured.invalid">
            {{ getError("error_uninsured") }}
          </small>
        </div>
      </div>
    </div>

    <div
      class="row"
      v-if="allow_driver_license && model.primary_insurance != 'Client Bill'"
    >
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label
            class="control-label"
            :class="{ required: required_driver_license }"
          >
            {{ translatedFields["driver_license"] }}
          </label>
          <label for="driver_license_image" class="upload-file-label">
            <h6 v-if="!model.driver_license_name">
              Choose file or take picture
            </h6>
            <h6 v-else class="elipsis">{{ model.driver_license_name }}</h6>
            <input
              :disabled="this.model.insurance_pay === 'cash'"
              class="upload-file"
              type="file"
              name="driver_license_image"
              id="driver_license_image"
              data-vv-as="Driver License"
              v-validate="modelValidations.driver_license_image"
              @change="onFileChangeDriverLicense"
              accept=".png, .jpg, .jpeg, .svg, .gif, .webp, .tiff, .bmp, .ico, .tif, .pdf"
            />
          </label>
          <small class="text-danger" v-show="driver_license_image.invalid">
            {{ getError("driver_license_image") }}
          </small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label class="control-label">
            {{ translatedFields["note"] }}
          </label>
          <div class="custom-file">
            <el-input type="textarea" v-model="model.note"></el-input>
          </div>
        </div>
      </div>
    </div>
    <br /><br />
  </div>
</template>

<script>
  import { mapFields } from 'vee-validate'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import {Input, Autocomplete} from 'element-ui'
  import axios from 'axios'
  import Cleave from 'cleave.js'
  import Address from './Address'
  require('cleave.js/dist/addons/cleave-phone.us')

  export default {
    components: {
      [Input.name]: Input,
      [Autocomplete.name]: Autocomplete,
      Address
    },
    mixins: [FormatterUtils, ValidationUtils],
    data () {
      return {
        address_error: '',
        same_address: false,
        allow_driver_license: String(process.env.ALLOW_DRIVER_LICENSE) === 'true',
        required_driver_license: String(process.env.REQUIRED_DRIVER_LICENSE) === 'true',
        smartystreets_key: process.env.SMARTYSTREETS_KEY,
        force_valid_address: String(process.env.FORCE_VALID_ADDRESS) === 'true',
        allow_insurance_card: String(process.env.ALLOW_INSURANCE_CARD) === 'true',
        required_insurance_card: String(process.env.REQUIRED_INSURANCE_CARD) === 'true',
        allow_cash: String(process.env.ALLOW_CASH) === 'true',
        allow_client_bill: String(process.env.ALLOW_CLIENT_BILL) === 'true',
        errorDate: '',
        translatedFields: '',
        fields_en: {
          if_your_insurance_is_not_available_in_the_list_please_select_other: 'If your insurance is not available in the list please select Other',
          driver_license: 'Driver License',
          social_security_number: 'Social Security Number',
          driver_license_number: 'Driver License Number',
          insured_address: 'Insured Address',
          insured_address2: 'Insured Address 2',
          same_as_previous: 'Same as previous',
          select_payment_type: 'Select payment Type',
          insurance: 'Insurance',
          uninsured: 'Uninsured',
          client_bill: String(process.env.CLIENT_BILL_NAME) !== 'undefined' ? String(process.env.CLIENT_BILL_NAME) : 'Client Bill',
          cash: 'Cash',
          please_provide_insurance_information: 'Please provide insurance information',
          primary_insurance_name: 'Primary Insurance Name',
          policy_number: 'Policy Number',
          group_number: 'Group Number',
          relationship_to_patient: 'Relationship to Patient',
          insured_first_name: 'Insured First Name',
          insured_last_name: 'Insured Last Name',
          insured_date_of_birth: 'Insured Date of Birth',
          insured_gender: 'Insured Gender',
          address_is_the_same_as_previously_entered: 'Address is the same as previously entered',
          insurance_card: 'Insurance Card',
          note: 'Note'
        },
        relationshipList: [{value: 'Self', label: 'Self'}, {value: 'Child', label: 'Child'}, {value: 'Parent', label: 'Parent'}, {value: 'Spouse', label: 'Spouse'}],
        model: {
          social_security_number: '',
          driver_license_number: '',
          driver_license_image: '',
          driver_license_name: '',
          primary_insurance: '',
          policy_number: '',
          group_number: '',
          relationship: '',
          insurance_pay: 'insurance',
          insured_first_name: '',
          insured_last_name: '',
          insured_date_of_birth: '',
          insured_date_of_birth_pretty: '',
          insured_address_components: '',
          insured_gender: '',
          insurance_card_image: '',
          insurance_card_name: '',
          error_uninsured: '',
          note: ''
        },
        modelValidations: {
          primary_insurance: {
            required: true
          },
          policy_number: {
            required: true
          },
          group_number: {
          },
          relationship: {
            required: true
          },
          insured_first_name: {
            required: true
          },
          insured_last_name: {
            required: true
          },
          insured_gender: {
            required: true
          },
          insurance_card_image: {
            required: String(process.env.REQUIRED_INSURANCE_CARD) === 'true'
          },
          insured_address: {
            min: 5,
            required: true
          },
          insured_address2: {},
          driver_license_number: {
          },
          social_security_number: {
            min: 9,
            max: 9
          },
          driver_license_image: {
            required: String(process.env.REQUIRED_DRIVER_LICENSE) === 'true'
          },
          error_uninsured: {}
        },
        address_smartystreets_selected: {
          invalid: false,
          error_message: 'Looks like we don\'t know this address, please make sure the address is correct',
          first_result: ''
        }
      }
    },
    methods: {
      updateAddress (data) {
        this.model.insured_address_components = data
        this.address_error = ''
      },
      translateFields (option) {
        let field = option.label.toLowerCase()
        if (this.$store.state.lang.value === 'ES' && this.$store.state.translation_es[field]) {
          return this.$store.state.translation_es[field]
        } else {
          if (this.$store.state.lang.value === 'ZH' && this.$store.state.translation_zh[field]) {
            return this.$store.state.translation_zh[field]
          } else {
            return option.label
          }
        }
      },
      onFileChangeInsurance (e) {
        let name = e.target.value
        this.model.insurance_card_name = name.substr(name.lastIndexOf('\\') + 1)
        var files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        this.createImageInsurance(files[0])
      },
      createImageInsurance (file) {
        var reader = new FileReader()
        var vm = this

        reader.onload = (e) => {
          vm.model.insurance_card_image = e.target.result
        }
        reader.readAsDataURL(file)
      },
      onFileChangeDriverLicense (e) {
        let name = e.target.value
        this.model.driver_license_name = name.substr(name.lastIndexOf('\\') + 1)
        var files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        this.createImageDriver(files[0])
      },
      createImageDriver (file) {
        var reader = new FileReader()
        var vm = this

        reader.onload = (e) => {
          vm.model.driver_license_image = e.target.result
        }
        reader.readAsDataURL(file)
      },
      triggerNextTab () {
        this.$emit('nextTab')
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async validate () {
        if (this.model.insurance_pay === 'uninsured') {
          if (this.allow_dl_or_ssn === 'true' && !this.model.driver_license_number && !this.model.social_security_number) {
            this.$validator.errors.add({field: 'error_uninsured', msg: 'Please complete your Driver License Number or your Social Number'})
            let field = this.$validator._resolveField('error_uninsured')
            field.setFlags({invalid: true})
            return false
          }
          this.address_error = ''
          if (!this.model.insured_address_components) {
            this.address_error = 'All the fields are required'
            return false
          }
          for (var o in this.model.insured_address_components) {
            if (!this.model.insured_address_components[o] && o !== 'county_fips' && o !== 'plus4_code') {
              this.address_error = 'All the fields are required'
              return false
            }
          }
        }
        if (!this.model.insured_date_of_birth && this.model.insurance_pay !== 'client_bill' && this.model.insurance_pay !== 'uninsured') {
          this.errorDate = 'Insured Date Of Birth field is required'
        } else if (!this.errorDate.includes('must be valid') &&
                !this.errorDate.includes('in the past') &&
                !this.errorDate.includes('in the future')) {
          this.errorDate = ''
        }
        if ((await this.$validator.validateAll() === true) && this.errorDate === '') {
          return true
        } else {
          return false
        }
      },
      switchInsuranceCash () {
        if (this.model.insurance_pay === 'uninsured') {
          this.changePaymentValue('UNINSURED')
        } else if (this.model.insurance_pay === 'cash') {
          this.changePaymentValue('CASH')
        } else if (this.model.insurance_pay === 'client_bill') {
          this.changePaymentValue('Client Bill')
        } else {
          this.changePaymentValue('')
        }
      },
      changePaymentValue (type) {
        this.model.primary_insurance = type
        this.model.policy_number = type
        this.model.group_number = type
        this.errorDate = ''
        this.hideAddressSmartystreetsError()
        this.model.insurance_card_image = ''
        this.model.driver_license_number = ''
        this.model.social_security_number = ''
        if (type === 'CASH' || type === 'UNINSURED') {
          this.model.relationship = 'Self'
          this.model.insured_first_name = this.$store.state.dataForInsurance.first_name
          this.model.insured_last_name = this.$store.state.dataForInsurance.last_name
          this.model.insured_date_of_birth = this.$store.state.dataForInsurance.dob
          this.model.insured_date_of_birth_pretty = this.$store.state.dataForInsurance.dob_pretty
          this.model.insured_gender = this.$store.state.dataForInsurance.gender
          this.model.insured_address_components = this.$store.state.dataForInsurance.addressComponents
          this.model.insured_address2 = this.$store.state.dataForInsurance.address2
        } else {
          this.model.relationship = ''
          this.model.insured_first_name = ''
          this.model.insured_last_name = ''
          this.model.insured_date_of_birth = ''
          this.model.insured_date_of_birth_pretty = ''
          this.model.insured_gender = ''
          this.model.insured_address = ''
          this.model.insured_address_components = ''
        }
      },
      checkLanguage () {
        if (this.$store.state.lang.value === 'ES') {
          this.translatedFields = this.$store.state.translation_es
        } else {
          if (this.$store.state.lang.value === 'ZH') {
            this.translatedFields = this.$store.state.translation_zh
          } else {
            this.translatedFields = this.fields_en
          }
        }
      },
      lookup (queryString, cb) {
        if (queryString) {
          axios
          .get('https://us-autocomplete-pro.api.smartystreets.com/lookup?key=' + this.smartystreets_key + '&search=' + queryString + '&max_results=5')
          .then(response => {
            this.suggestions = []
            var arr = []
            if (response.data.suggestions) {
              response.data.suggestions.forEach((suggestion) => {
                arr.push({
                  value: suggestion.street_line + ', ' + suggestion.city + ', ' + suggestion.state + ' ' + suggestion.zipcode
                })
              })
              let links = arr
              let results = queryString ? links.filter(this.createFilter(queryString)) : links
              if (results.length === 1) {
                this.address_smartystreets_selected.first_result = results[0].value
              }
              // call callback function to return suggestions
              cb(results)
            } else {
              let error = []
              let links = error
              let results = queryString ? links.filter(this.createFilter(queryString)) : links
              cb(results)
            }
          })
          .catch(error => {
            console.log(error)
            // this.userMessage('Error getting bill fields: ' + error.message, 'error');
          })
        }
      },
      createFilter (queryString) {
        return (link) => {
          return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      showAddressSmartystreetsError () {
        if (this.force_valid_address) {
          this.address_smartystreets_selected.invalid = true
          this.errors.add({ // to do
            field: 'insured_address',
            msg: this.address_smartystreets_selected.error_message
          })
        }
      },
      hideAddressSmartystreetsError () {
        this.address_smartystreets_selected.invalid = false
        this.errors.remove({
          field: 'insured_address'
        })
      },
      handleAddressBlur (item) {
        let showAddressSmartystreetsError = true
        if (typeof item.target !== 'undefined' && item.target.value !== 'undefined') {
          if (this.address_smartystreets_selected.first_result !== '' &&
                  this.address_smartystreets_selected.first_result.toLowerCase().indexOf(item.target.value.toLowerCase()) === 0) {
            showAddressSmartystreetsError = false
            item.target.value = this.address_smartystreets_selected.first_result
            this.model.address = this.address_smartystreets_selected.first_result
            this.hideAddressSmartystreetsError()
          }
        }
        if (showAddressSmartystreetsError === true) {
          this.showAddressSmartystreetsError()
        }

        this.$on('input', function () {
          this.hideAddressSmartystreetsError()
        })
      },
      handleAddressSelect (item) {
        this.$emit('input', item.value)
      }
    },
    computed: {
      allow_dl_or_ssn () {
        return this.$store.state.allow_dl_or_ssn
      },
      insurance_pay: {
        model: {
          get () {
            return this.model.insurance_pay
          },
          set (value) {
            this.$emit('input', value)
          }
        }
      },
      language () {
        this.checkLanguage()
        return this.$store.state.lang.value
      },
      spanishFields () {
        return this.$store.state.translation_es
      },
      chineseFields () {
        return this.$store.state.translation_zh
      },
      storedFirstName () {
        return this.$store.state.dataForInsurance.first_name
      },
      storedLastName () {
        return this.$store.state.dataForInsurance.last_name
      },
      storedDob () {
        return this.$store.state.dataForInsurance.dob
      },
      storedDobPretty () {
        return this.$store.state.dataForInsurance.dob_pretty
      },
      storedGender () {
        return this.$store.state.dataForInsurance.gender
      },
      storedAddress () {
        if (this.model.relationship === 'Self') {
          this.sameAddress = this.$store.state.dataForInsurance.addressComponents
          return this.$store.state.dataForInsurance.addressComponents
        }
        this.sameAddress = ''
        return ''
      },
      ...mapFields(['primary_insurance', 'policy_number', 'group_number', 'relationship', 'insurance_pay', 'insured_first_name', 'insured_last_name', 'insured_date_of_birth', 'insured_date_of_birth_pretty', 'insured_gender', 'insurance_card_image', 'insured_address', 'error_uninsured', 'driver_license_image', 'driver_license_number', 'social_security_number'])
    },
    watch: {
      same_address () {
        if (this.same_address) {
          this.sameAddress = this.$store.state.dataForInsurance.addressComponents
          this.model.insured_address_components = this.$store.state.dataForInsurance.addressComponents
        } else {
          this.sameAddress = ''
          this.model.insured_address_components = ''
        }
      },
      language () {
        this.checkLanguage()
      },
      storedFirstName () {
        if (this.model.relationship === 'Self') {
          this.model.insured_first_name = this.$store.state.dataForInsurance.first_name
        }
      },
      storedLastName () {
        if (this.model.relationship === 'Self') {
          this.model.insured_last_name = this.$store.state.dataForInsurance.last_name
        }
      },
      storedDob () {
        if (this.model.relationship === 'Self') {
          this.model.insured_date_of_birth = this.$store.state.dataForInsurance.dob
        }
      },
      storedDobPretty () {
        if (this.model.relationship === 'Self') {
          this.model.insured_date_of_birth_pretty = this.$store.state.dataForInsurance.dob_pretty
        }
      },
      storedGender () {
        if (this.model.relationship === 'Self') {
          this.model.insured_gender = this.$store.state.dataForInsurance.gender
        }
      },
      storedAddress () {
        if (this.model.relationship === 'Self') {
          this.sameAddress = this.$store.state.dataForInsurance.addressComponents
          this.model.insured_address_components = this.$store.state.dataForInsurance.addressComponents
        } else {
          this.sameAddress = ''
        }
      },
      'model.relationship': {
        handler: function (after, before) {
          this.model.insured_first_name = ''
          this.model.insured_last_name = ''
          this.model.insured_date_of_birth = ''
          this.model.insured_date_of_birth_pretty = ''
          this.model.insured_gender = ''
          this.model.insured_address_components = ''
          this.sameAddress = ''
          if (this.model.relationship === 'Self') {
            this.errorDate = ''
            this.model.insured_first_name = this.$store.state.dataForInsurance.first_name
            this.model.insured_last_name = this.$store.state.dataForInsurance.last_name
            this.model.insured_date_of_birth_pretty = this.$store.state.dataForInsurance.dob_pretty
            this.model.insured_date_of_birth = this.$store.state.dataForInsurance.dob
            this.model.insured_gender = this.$store.state.dataForInsurance.gender
            this.model.insured_address_components = this.$store.state.dataForInsurance.addressComponents
            this.sameAddress = this.$store.state.dataForInsurance.addressComponents
          } else {
            this.errorDate = 'Insurance Date Of Birth field is required'
          }
        },
        deep: true
      },
      'model.insured_date_of_birth_pretty': {
        handler: function (dobValue) {
          if (dobValue !== '' && (this.model.insurance_pay !== 'uninsured' || this.model.insurance_pay !== 'cash' || this.model.insurance_pay !== 'client_bill') && this.model.relationship !== 'Self') {
            let dateCleave = new Cleave('.date-insured-cleave-format', {
              date: true,
              delimiter: '/',
              datePattern: ['m', 'd', 'Y']
            })
            this.model.insured_date_of_birth_pretty = dateCleave.getFormattedValue()
            if (dobValue.length === 10) {
              let dateParts = dobValue.split('/')
              this.model.insured_date_of_birth = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1]
            }
          }
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
#select-payment{
  padding: 0px !important;
  line-height: 29px;
}

.required:after {
  content:" *";
  color: red;
}

.margin{
  margin-top: 20px;
  margin-bottom: 10px;
}

>>> .el-select--large{
  width: 100%;
}

>>> .el-textarea__inner {
  border-color: #9A9A9A;
}

.el-select-dropdown__item {
  max-width: 100%;
  overflow: hidden;
  word-wrap: normal !important;
  word-break: break-word;
  white-space: pre-wrap;
  height: auto;
}

@media (max-width: 400px) {
  .el-popper[x-placement^="top"] {
    left: 0px !important;
  }

  .el-popper[x-placement^="bottom"] {
    left: 0px !important;
  }
}

.display-block{
  display: block;
}

.display-inline{
  margin-left: 5px;
  display: inline;
}

.display-none{
  display: none;
}

.border-none{
  border: none;
}

.upload-file{
  width: 0;
  height: 0;
}

.upload-file-label{
  display: block;
  background-color: #31bebf;
  color: white;
  padding: 10px;
  text-align: center;
  border-radius: 6px;
  cursor: pointer;
}

.elipsis{
  text-overflow: ellipsis;
  overflow: hidden; 
  width: auto; 
  height: 1.2em; 
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/Wizard/InsuranceStep.vue